// extracted by mini-css-extract-plugin
export default {"ModalContent":"styles_ModalContent__sYq9y","title":"styles_title__DqcBK","pairs":"styles_pairs__u4cd+","loupe":"styles_loupe__p2d0+","label":"styles_label__YqfkO"};